const assignmentStatusByCode = {
  0: { label: "Unassigned", filterValue: "unassigned", color: "red" },
  1: { label: "Pending", filterValue: "pending", color: "#D48806" },
  2: { label: "Unassigned", filterValue: "unassigned", color: "red" },
  3: { label: "Assigned", filterValue: "assigned", color: "green" },
};

export const getAssignmentStatus = (status) =>
  assignmentStatusByCode[Number(status)] || {
    label: "Unknown",
    filterValue: "unknown",
    color: "#595959",
  };
